import { Switches } from "mui-rff";
import { useMemo } from "react";
import { useField } from "react-final-form";
import { CollectionItem } from "@ark-ui/react";

import { useTranslation } from "@/lib/i18n";
import { useGetCapabilitiesQuery } from "@/features/admin/hooks/queries";
import { EdrObservationsMapLayer } from "@/lib/api";

import EDRParameterSet from "./EDRParameterSet";

type EDRConfigurationProps = { name: string; initialValue: EdrObservationsMapLayer };

const EDRConfiguration = ({ name, initialValue }: EDRConfigurationProps) => {
  const { t } = useTranslation();
  const edrParamsQuery = useGetCapabilitiesQuery("knmi_dataplatform_edr_observations");
  useField(`${name}.show_all_locations`, {
    initialValue: initialValue.show_all_locations ?? false,
  });

  const edrParamsQueryOptions = useMemo(() => {
    if (!edrParamsQuery.data?.parameters) return [];

    return edrParamsQuery.data.parameters.map(
      (params) =>
        ({
          label: params.description,
          value: params.id,
          group: params.unit.symbol,
        }) as CollectionItem,
    );
  }, [edrParamsQuery.data]);

  if (!edrParamsQuery.isSuccess) return null;

  return (
    <>
      <EDRParameterSet
        name={name}
        parameters={edrParamsQueryOptions}
        initialValue={initialValue}
      />
      <Switches
        name={`${name}.show_all_locations`}
        data={{
          label: t("admin.widgets.fields.map.layer.show_all_locations"),
          value: false,
        }}
      />
    </>
  );
};

export default EDRConfiguration;
